function AccountListController(userService, $uibModal, __env) {
  const ctrl = this;
  ctrl.$onInit = () => {
    ctrl.showOnlyOnline = false;
    ctrl.sortType = 'name'; // set the default sort type
    ctrl.sortReverse = false; // set the default sort order
    ctrl.search = ''; // set the default search/filter term
  };

  ctrl.$onChanges = changes => {

    ctrl.accounts = angular.copy(filterAccounts(ctrl.allAccounts));
    ctrl.hasModifyUsers = userService.hasModifyUsers();
    ctrl.hasReadReportSetting = userService.hasReadReportSetting();
    ctrl.hasCreateReportSetting = userService.hasCreateReportSetting();
    ctrl.env = __env;
  };

  ctrl.additionalRoles = account => {
    let roles = '';
    if (account.tipUser) {
      roles += ' TIP';
    }
    return roles;
  };

  ctrl.isUserLoggedIn = id => ctrl.allAccounts.find(v => v.id === id ).online;

  const filterAccounts = data => {
    if (ctrl.showOnlyOnline) {
      data = _.filter(data, item => item.online);
    }
    return data;
  };

  ctrl.setSortType = column => {
    ctrl.sortType = column;
  };

  ctrl.setSortReverse = () => {
    ctrl.sortReverse = !ctrl.sortReverse;
  };

  ctrl.openUserModal = (account, $event) => {
    $event.stopPropagation();
    if (!ctrl.hasModifyUsers) return;
    const modalInstance = $uibModal.open({
      component: 'userModal',
      resolve: {
        type: function() {
          return 'edit';
        },
        account: function() {
          return account;
        },
        currentUser: function(userService) {
          return userService.isCurrentUser(account.id);
        },
        userGroups: () => {
          return ctrl.userGroups;
        },
      },
    });

    modalInstance.result.then(function() {}, function() {});
  };

  ctrl.editReportSettings = (account, $event) => {
    $event.stopPropagation();
    if (!userService.hasCreateReportSetting) return;
    const modalInstance = $uibModal.open({
      component: 'reportSettingsModal',
      resolve: {
        account: function() {
          return account;
        }
      },
    });
    modalInstance.result.then(function() {}, function() {});
  };

  ctrl.openAddAccount = () => {
    if (!ctrl.hasModifyUsers) return;
    const modalInstance = $uibModal.open({
      component: 'userModal',
      resolve: {
        type: function () {
          return 'add';
        },
        account: function () {
          return {};
        },
        currentUser: function () {
          return false;
        },
        userGroups: () => {
          return ctrl.userGroups;
        },
      },
    });

    modalInstance.result.then(function() {}, function() {});
  };
}

angular
  .module('users.module')
  .controller('AccountListController', AccountListController);
